import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import {
	GanttData,
	GanttDelay,
	GanttEvent,
	GanttWorkOrder,
	ViewMode,
} from "../models/types";

const moment = getMomentTz();

export const getGanttData = async (
	start: Date | null,
	end: Date | null,
	viewMode: ViewMode = "Bundles",
	assetId?: number | null,
	assetIds?: number[] | null,
): Promise<GanttData> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start ? start.toISOString() : null },
		{ name: "End", value: end ? end.toISOString() : null },
		{ name: "ViewMode", value: viewMode },
		{ name: "AssetId", value: assetId ?? null },
		{
			name: "AssetIds",
			value: assetIds && assetIds.length ? assetIds.join(",") : null,
		},
	];

	const resp = await apiService.callV2("[FAB].[GetGanttData]", parameters);
	if (resp.ok) {
		const events = get(resp, "data.tables[0].rows", []).map(
			(row: GanttEvent) => ({
				...row,
				Start: row.Start ? moment.utc(row.Start).toDate() : null,
				End: row.End ? moment.utc(row.End).toDate() : null,
			}),
		) as GanttEvent[];

		const delays = get(resp, "data.tables[1].rows", []).map(
			(row: GanttDelay) => ({
				...row,
				Start: row.Start ? moment.utc(row.Start).toDate() : null,
				End: row.End ? moment.utc(row.End).toDate() : null,
			}),
		) as GanttDelay[];

		const workOrders = get(resp, "data.tables[2].rows", []).map(
			(row: GanttWorkOrder) => ({
				...row,
				Start: row.Start ? moment.utc(row.Start).toDate() : null,
				End: row.End ? moment.utc(row.End).toDate() : null,
			}),
		) as GanttWorkOrder[];

		return { events, delays, workOrders };
	}
	throw new Error(resp.message || "Error fetching gantt data");
};
